import { getLoginInfo } from "../auth/getLoginInfo";
import { createAxios, createAxiosWithToken, createAxiosWithTokenFile } from "./createAxios";

export async function SearchUser(params) {
  let loginData = getLoginInfo();
  if (loginData)
    return await createAxiosWithToken(loginData.token).get(
      "/ApplicationUser/SearchUser?PageNo=" +
      params.PageNo +
      "&PageSize=" +
      params.PageSize +
      "&SearchTerm=" +
      params.SearchTerm
    );
}

export async function SearchPendingUser(params) {
  let loginData = getLoginInfo();
  if (loginData)
    return await createAxiosWithToken(loginData.token).get(
      "/ApplicationUser/SearchPendingUser?PageNo=" +
      params.PageNo +
      "&PageSize=" +
      params.PageSize +
      "&SearchTerm=" +
      params.SearchTerm
    );
}

export async function SearchUserAdmin(params) {
  let loginData = getLoginInfo();
  if (loginData)
    return await createAxiosWithToken(loginData.token).get(
      "/ApplicationUser/SearchUserAdmin?PageNo=" +
      params.PageNo +
      "&PageSize=" +
      params.PageSize +
      "&SearchTerm=" +
      params.SearchTerm
    );
}

export async function SearchUserByCity(params) {
  return await createAxios().get(
    "/ApplicationUser/SearchUserByCity?PageNo=" +
    params.PageNo +
    "&PageSize=" +
    params.PageSize +
    "&SearchTerm=" +
    params.SearchTerm +
    "&CityId=" +
    params.CityId
  );

}

export async function SearchRandomUsers(params) {
  return await createAxios().get(
    "/ApplicationUser/SearchRandomUsers?Count=" + params.count
  );

}

export async function GetById() {
  let loginData = getLoginInfo();
  if (loginData)
    return await createAxiosWithToken(loginData.token).get("/ApplicationUser/GetById?Id=" + loginData.id);
}

export async function GetByUserName(username) {
  let loginData = getLoginInfo();
  if (loginData)
    return await createAxiosWithToken(loginData.token).get(
      "/ApplicationUser/GetByUserName?UserName=" + username
    );
}

export async function Update(params) {
  let loginData = getLoginInfo();
  if (loginData)
    return await createAxiosWithToken(loginData.token).post(
      "/ApplicationUser/Update",
      params
    );
}

export async function ChangePassword(params) {
  let loginData = getLoginInfo();
  if (loginData)
    return await createAxiosWithToken(loginData.token).post(
      "/ApplicationUser/ChangePassword",
      params
    );
}
export async function ResetPassword(params) {
  let loginData = getLoginInfo();
  if (loginData)
    return await createAxiosWithToken(loginData.token).post(
      "/ApplicationUser/ResetPassword",
      params
    );
}
export async function ChangePin(params) {
  let loginData = getLoginInfo();
  if (loginData)
    return await createAxiosWithToken(loginData.token).post(
      "/ApplicationUser/ChangePin",
      params
    );
}
export async function ResetPin(params) {
  let loginData = getLoginInfo();
  if (loginData)
    return await createAxiosWithToken(loginData.token).post(
      "/ApplicationUser/ResetPin",
      params
    );
}

export async function Add(params) {
  let loginData = getLoginInfo();
  if (loginData)
    return await createAxiosWithToken(loginData.token).post(
      "/api/ApplicationUser/Add",
      params
    );
}

export async function ForgotPassword(params) {
  return await createAxios().post(
    "/ApplicationUser/ForgotPassword?UserName=" +
    params.UserName +
    "&OTP=" +
    params.OTP +
    "&NewPass=" +
    params.NewPass +
    "&ConfirmPassword" +
    params.ConfirmPassword
  );
}

export async function ForgotPasswordInitiate(params) {
  return await createAxios().post(
    "/ApplicationUser/ForgotPasswordInitiate?UserName=" + params.UserName
  );
}

export async function UpdateStatus(params) {
  let loginData = getLoginInfo();
  if (loginData)
    return await createAxiosWithToken(loginData.token).post(
      "/ApplicationUser/UpdateStatus",
      params
    );
}

export async function UploadDP(params) {
  let loginData = getLoginInfo();
  if (loginData)
    return await createAxiosWithTokenFile(loginData.token).post(
      "/ApplicationUser/UploadDP",
      params
    );
}

export async function UnloadDP(params) {
  let loginData = getLoginInfo();
  if (loginData)
    return await createAxiosWithToken(loginData.token).post(
      "/ApplicationUser/UnloadDP",
      params
    );
}

export async function UploadHeader(params) {
  let loginData = getLoginInfo();
  if (loginData)
    return await createAxiosWithTokenFile(loginData.token).post(
      "/ApplicationUser/UploadHeader",
      params
    );
}

export async function UnloadHeader(params) {
  let loginData = getLoginInfo();
  if (loginData)
    return await createAxiosWithToken(loginData.token).post(
      "/ApplicationUser/UnloadHeader",
      params
    );
}

export async function UploadFooter(params) {
  let loginData = getLoginInfo();
  if (loginData)
    return await createAxiosWithTokenFile(loginData.token).post(
      "/ApplicationUser/UploadFooter",
      params
    );
}

export async function UnloadFooter(params) {
  let loginData = getLoginInfo();
  if (loginData)
    return await createAxiosWithToken(loginData.token).post(
      "/ApplicationUser/UnloadFooter",
      params
    );
}

export async function UploadSide(params) {
  let loginData = getLoginInfo();
  if (loginData)
    return await createAxiosWithTokenFile(loginData.token).post(
      "/ApplicationUser/UploadSide",
      params
    );
}

export async function UnloadSide(params) {
  let loginData = getLoginInfo();
  if (loginData)
    return await createAxiosWithToken(loginData.token).post(
      "/ApplicationUser/UnloadSide",
      params
    );
}

export async function UploadWaterMark(params) {
  let loginData = getLoginInfo();
  if (loginData)
    return await createAxiosWithTokenFile(loginData.token).post(
      "/ApplicationUser/UploadWaterMark",
      params
    );
}

export async function UnloadWaterMark(params) {
  let loginData = getLoginInfo();
  if (loginData)
    return await createAxiosWithToken(loginData.token).post(
      "/ApplicationUser/UnloadWaterMark",
      params
    );
}


export async function VerifyPin(params) {
  let loginData = getLoginInfo();
  if (loginData)
    return await createAxiosWithToken(loginData.token).post(
      "/ApplicationUser/VerifyPin?Pin=" + params.Pin + "&UserId" + params.UserId
    );
}

export async function ForgotPin(params) {
  let loginData = getLoginInfo();
  if (loginData)
    return await createAxiosWithToken(loginData.token).post(
      "/ApplicationUser/ForgotPin",
      params
    );
}

export async function ForgotPinInitiate(params) {
  let loginData = getLoginInfo();
  if (loginData)
    return await createAxiosWithToken(loginData.token).post(
      "/ApplicationUser/ForgotPinInitiate?UserName=" + params.UserName
    );
}

export async function CheckNewDoctorId(params) {
  let loginData = getLoginInfo();
  if (loginData)
    return await createAxiosWithToken(loginData.token).post(
      "/ApplicationUser/CheckNewDoctorId?NewDoctorId=" + params.NewDoctorId
    );
}

export async function UpdateDoctorId(params) {
  let loginData = getLoginInfo();
  if (loginData)
    return await createAxiosWithToken(loginData.token).post(
      "/ApplicationUser/UpdateDoctorId?NewDoctorId=" + params.NewDoctorId
    );
}

export async function Getbalance() {
  let loginData = getLoginInfo();
  if (loginData)
    return await createAxiosWithToken(loginData.token).get(
      "/ApplicationUser/Getbalance"
    );
}